import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import { styled } from "@mui/system";
import Table from "./Table";
import { useUser } from "../Contexts/UserContext";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;

// Custom Box to center content
const Container = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-around",
  backgroundColor: "#f5f5f5",
  padding: "8px 15px",
  borderRadius: "8px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  width: "270px", // Compact width
  textAlign: "center",
  marginBottom: "10px",
});

// Styled title
const Title = styled(Typography)({
  fontSize: "14px",
  fontWeight: "600",
  color: "#D10101", // Custom color
  marginBottom: "4px",
  textTransform: "uppercase",
  letterSpacing: "1px",
  fontFamily: "Poppins, sans-serif",
});

// Styled number
const Number = styled(Typography)({
  fontSize: "32px",
  fontWeight: "bold",
  color: "#333",
});

const SiteVisit = ({ number = 0 }) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { user } = useUser();
  const { ClientId, CompCode } = user;

  const handleOpen = () => {
    setOpen(true);
    fetchData();
  };
  const handleClose = () => {
    setOpen(false);
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `${API_URL}/facility/get-facility-cards-data/5/${CompCode}/${ClientId}/:fromDate/:toDate`
      ).then((res) => res.json());
      setData(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };
  return (
    <Container>
      <Box>
        <Title>SiteVisit Completed</Title>
        <Number>{number}</Number>
        <Button onClick={handleOpen}>view</Button>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box
          sx={{
            width: 800,
            bgcolor: "background.paper",
            // border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          {loading ? (
            <CircularProgress />
          ) : data ? (
            <Table data={data} itemsPerPage={10} />
          ) : (
            "No data available"
          )}
        </Box>
      </Modal>
    </Container>
  );
};

export default SiteVisit;
